import { EventCreatorMap } from '@app/analytics/models/helpers';

import manualSearch from './manual';
import autocomplete from './autocomplete';

import * as SearchActions from '@app/store/actions/search.action';

const eventsMap: EventCreatorMap = {
  [SearchActions.MANUAL_SEARCH]: manualSearch,
  [SearchActions.AUTOCOMPLETE_SEARCH]: autocomplete
};

export default eventsMap;
